import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminApiError } from '@/services/adminService';
import { ApiError } from '@/services/api';

export function useAdminApi() {
  const navigate = useNavigate();

  const handleError = useCallback((err: unknown) => {
    if (err instanceof AdminApiError || err instanceof ApiError) {
      const status = 'status' in err ? err.status : 0;
      if (status === 401) {
        navigate('/login', { replace: true });
        return true;
      }
      if (status === 403) {
        navigate('/forbidden', { replace: true });
        return true;
      }
    }
    return false;
  }, [navigate]);

  return { handleError };
}